import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { VideoHub } from '../components/VideoHub';

export const VideoHubProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <VideoHub {...data} />
        </Provider>
    );
};

export default VideoHubProvider;

VideoHubProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
